/* home.icon.svg.js */

module.exports = {
    icon: `<svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" d="M23.9377 8.80442V1.6292H19.8763V5.14912L14.461 0.275391L0.922852 12.4597H4.98429V23.2902H11.7534V15.1673H17.1686V23.2902H23.9377V12.4597H27.9991L23.9377 8.80442ZM11.7534 9.75209C11.7534 8.2629 12.9718 7.04446 14.461 7.04446C15.9502 7.04446 17.1686 8.2629 17.1686 9.75209H11.7534Z" fill="#5D6F80"/>
  </svg>  
    `
};
